export const MESES_LIST = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
] as const;

export type MESES_TYPE = (typeof MESES_LIST)[number];

export const MESES_OPTIONS = MESES_LIST.map((mes, index) => ({
  label: mes,
  value: index + 1,
}));
